/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import '@neo4j-ndl/base/lib/neo4j-ds-styles.css';

import {
  Combobox,
  FilledButton,
  OutlinedButton,
  TextButton,
  Typography,
} from '@neo4j-ndl/react';
import { type FormEvent, useRef, useState } from 'react';

const products = [
  { label: 'Neo4j', value: 'neo4j' },
  { label: 'Aura', value: 'aura' },
  { label: 'Bloom', value: 'bloom' },
];

const environments = [
  { label: 'Development', value: 'development' },
  { label: 'Staging', value: 'staging' },
  { label: 'Production', value: 'production' },
];

const Component = () => {
  const triggerRef = useRef<HTMLElement | null>(null);
  const [submittedValues, setSubmittedValues] = useState<string[]>([]);

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setSubmittedValues(
      Array.from(new FormData(event.currentTarget).entries()).map(
        ([name, value]) => `${name}: ${String(value)}`,
      ),
    );
  };

  return (
    <form
      className="n-flex n-max-w-xl n-flex-col n-gap-token-6"
      onSubmit={handleSubmit}
    >
      <Combobox
        label="Product"
        name="product"
        options={products}
        defaultValue={products[0]}
        isRequired
        hasRequiredIndicator
        triggerRef={triggerRef}
      />
      <Combobox
        label="Environments"
        name="environment"
        options={environments}
        defaultValue={[environments[0], environments[1]]}
        isMulti
      />
      <div className="n-flex n-flex-wrap n-gap-token-2">
        <FilledButton type="submit">Submit</FilledButton>
        <OutlinedButton type="reset">Reset</OutlinedButton>
        <TextButton type="button" onClick={() => triggerRef.current?.focus()}>
          Focus product
        </TextButton>
      </div>
      <div aria-live="polite">
        <Typography variant="body-medium">Submitted form data</Typography>
        <pre className="n-mt-token-2">
          {submittedValues.length > 0
            ? submittedValues.join('\n')
            : 'Submit the form to inspect its values.'}
        </pre>
      </div>
    </form>
  );
};

export default Component;
